// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contactus-container {
  margin-top: 1rem;
}

.contactus-text {
  cursor: pointer;
}

.contactus-text span {
  text-decoration: underline;
  font-weight: 600;
}

.contactus-textbox-container {
  /* width: 95%; */
  background: #333333;
  padding: 1.6rem 1.425rem;
  position: relative;
}

.contactus-textbox-container .contactus-close-icon {
  position: absolute;
  top: 0.625rem;
  right: 0.625rem;
  width: 1rem;
  height: 1rem;
  cursor: pointer;
}

.contactus-label-text {
  font-size: 1.175rem;
  font-weight: 400;
  line-height: 28px;
  color: #fff;
}

.contactus-input-container {
  width: 100%;
  margin-top: 1rem;
  position: relative;
}
.contactus-input-container input {
  width: 100%;
  padding: 1rem 2.545rem 1rem 1.245rem;
  box-sizing: border-box;
  background: #040404;
  outline: none;
  color: #fff;
  border: 1px solid #676767;
}
.contactus-input-container input:focus {
  -webkit-box-shadow: 0 0 0 30px black inset !important;
}
.contactus-input-container input:-webkit-autofill {
  -webkit-text-fill-color: rgb(255, 255, 255) !important;
}
.contactus-input-container input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px black inset !important;
  color: #fff;
}
.contactus-input-container::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #fff;
}

.contactus-input-container .contactus-send-icon {
  position: absolute;
  right: 1.245rem;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}
.contactus-input-container .contactus-send-icon.inactive {
  cursor: not-allowed;
}
.contactus-input-container input:focus,
.contactus-input-container input:active {
  background: transparent;
  outline: none;
}

.contactus-textbox-container .contactus-success-header {
  margin-bottom: 0.6rem;
  font-size: 1.6rem;
  font-weight: 700;
  text-align: center;
  font-family: "Poppins", sans-serif;
  text-decoration: underline;
  text-align: center;
  cursor: pointer;
  background: linear-gradient(90deg, #ffde31 41.31%, #ff3db2 55.42%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.contactus-textbox-container .contactus-success-text {
  text-align: center;
  font-size: 1rem;
  margin-bottom: 0.6rem;
  font-family: "Calibre";
  color: #fff;
}

.contactus-success-toggle {
  width: auto;
  padding: 0.6rem 0.6rem;
  background: #fff;
  color: #000;
  font-weight: 700;
  font-size: 1rem;
  text-align: center;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 1.6rem;
  cursor: pointer;
  margin: 0 2rem;
}

.contactus-success-toggle span {
  height: 1.1rem;
}

@keyframes inAnimation {
  0% {
    opacity: 0;
    transform: translate3d(0, 20px, 0);
  }
  100% {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

@keyframes outAnimation {
  0% {
    opacity: 1;
    max-height: 600px;
  }
  100% {
    opacity: 0;
    max-height: 0px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/contactus/contactus.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,oCAAoC;EACpC,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,qDAAqD;AACvD;AACA;EACE,sDAAsD;AACxD;AACA;;;;EAIE,qDAAqD;EACrD,WAAW;AACb;AACA;EACE,yCAAyC;EACzC,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,QAAQ;EACR,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,kCAAkC;EAClC,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,kEAAkE;EAClE,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;IACV,kCAAkC;EACpC;EACA;IACE,UAAU;IACV,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,UAAU;IACV,iBAAiB;EACnB;EACA;IACE,UAAU;IACV,eAAe;EACjB;AACF","sourcesContent":[".contactus-container {\n  margin-top: 1rem;\n}\n\n.contactus-text {\n  cursor: pointer;\n}\n\n.contactus-text span {\n  text-decoration: underline;\n  font-weight: 600;\n}\n\n.contactus-textbox-container {\n  /* width: 95%; */\n  background: #333333;\n  padding: 1.6rem 1.425rem;\n  position: relative;\n}\n\n.contactus-textbox-container .contactus-close-icon {\n  position: absolute;\n  top: 0.625rem;\n  right: 0.625rem;\n  width: 1rem;\n  height: 1rem;\n  cursor: pointer;\n}\n\n.contactus-label-text {\n  font-size: 1.175rem;\n  font-weight: 400;\n  line-height: 28px;\n  color: #fff;\n}\n\n.contactus-input-container {\n  width: 100%;\n  margin-top: 1rem;\n  position: relative;\n}\n.contactus-input-container input {\n  width: 100%;\n  padding: 1rem 2.545rem 1rem 1.245rem;\n  box-sizing: border-box;\n  background: #040404;\n  outline: none;\n  color: #fff;\n  border: 1px solid #676767;\n}\n.contactus-input-container input:focus {\n  -webkit-box-shadow: 0 0 0 30px black inset !important;\n}\n.contactus-input-container input:-webkit-autofill {\n  -webkit-text-fill-color: rgb(255, 255, 255) !important;\n}\n.contactus-input-container input:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ninput:-webkit-autofill:active {\n  -webkit-box-shadow: 0 0 0 30px black inset !important;\n  color: #fff;\n}\n.contactus-input-container::placeholder {\n  /* Chrome, Firefox, Opera, Safari 10.1+ */\n  color: #fff;\n}\n\n.contactus-input-container .contactus-send-icon {\n  position: absolute;\n  right: 1.245rem;\n  top: 50%;\n  transform: translateY(-50%);\n  cursor: pointer;\n}\n.contactus-input-container .contactus-send-icon.inactive {\n  cursor: not-allowed;\n}\n.contactus-input-container input:focus,\n.contactus-input-container input:active {\n  background: transparent;\n  outline: none;\n}\n\n.contactus-textbox-container .contactus-success-header {\n  margin-bottom: 0.6rem;\n  font-size: 1.6rem;\n  font-weight: 700;\n  text-align: center;\n  font-family: \"Poppins\", sans-serif;\n  text-decoration: underline;\n  text-align: center;\n  cursor: pointer;\n  background: linear-gradient(90deg, #ffde31 41.31%, #ff3db2 55.42%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.contactus-textbox-container .contactus-success-text {\n  text-align: center;\n  font-size: 1rem;\n  margin-bottom: 0.6rem;\n  font-family: \"Calibre\";\n  color: #fff;\n}\n\n.contactus-success-toggle {\n  width: auto;\n  padding: 0.6rem 0.6rem;\n  background: #fff;\n  color: #000;\n  font-weight: 700;\n  font-size: 1rem;\n  text-align: center;\n  box-sizing: border-box;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 1.6rem;\n  cursor: pointer;\n  margin: 0 2rem;\n}\n\n.contactus-success-toggle span {\n  height: 1.1rem;\n}\n\n@keyframes inAnimation {\n  0% {\n    opacity: 0;\n    transform: translate3d(0, 20px, 0);\n  }\n  100% {\n    opacity: 1;\n    transform: translate3d(0, 0, 0);\n  }\n}\n\n@keyframes outAnimation {\n  0% {\n    opacity: 1;\n    max-height: 600px;\n  }\n  100% {\n    opacity: 0;\n    max-height: 0px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
